import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['editForm', 'editButton', 'input', 'copyButton', 'warning']

  showEdit() {
    this.editFormTarget.classList.remove('hidden')
    this.editButtonTarget.classList.add('hidden')
  }

  hideEdit() {
    this.editFormTarget.classList.add('hidden')
    this.editButtonTarget.classList.remove('hidden')
    this.clearWarning()
  }

  // Strip protocol and trailing slashes on blur, then validate
  formatInput(event) {
    const raw = event.target.value

    // Strip protocol
    let cleaned = raw
      .replace(/^https?:\/\//i, '')
      .toLowerCase()
      .trim()

    // If a path is present, strip it and warn
    if (/\/.+/.test(cleaned)) {
      cleaned = cleaned.replace(/\/.*$/, '')
      this.showWarning('path')
    }
    else {
      // Validate subdomain structure
      const parts = cleaned.split('.')
      if (cleaned.length > 0 && parts.length < 3) {
        // Looks like a root domain (e.g. "example.com") with no subdomain,
        // or just a bare word — warn but don't block
        this.showWarning('noSubdomain')
      }
      else {
        this.clearWarning()
      }
    }

    event.target.value = cleaned
  }

  // Prevent form submission if a path is still present
  validateSubmit(event) {
    const value = this.inputTarget.value
    if (/\//.test(value)) {
      event.preventDefault()
      this.showWarning('path')
      this.inputTarget.focus()
    }
  }

  showWarning(type) {
    if (!this.hasWarningTarget) return
    const messages = {
      path: `
        <div class="font-bold">Paths aren't supported.</div>
        <div>We've removed the path for you — please confirm the subdomain looks right before saving.</div>
      `,
      noSubdomain: `
        <div class="font-bold">No subdomain detected.</div>
        <div>It looks like you've entered a root domain (e.g. <span class="font-mono">yourdomain.com</span>).</div>
        <div>We recommend using a subdomain like <span class="font-mono">gallery.yourdomain.com</span> instead.</div>
        <div>If you use the root domain, <span class="font-bold">all traffic to your site will route to your Darkroom gallery.</span></div>
      `,
    }
    this.warningTarget.innerHTML = messages[type] ?? ''
    this.warningTarget.classList.remove('hidden')
  }

  clearWarning() {
    if (!this.hasWarningTarget) return
    this.warningTarget.classList.add('hidden')
    this.warningTarget.innerHTML = ''
  }

  copy(event) {
    const value = event.currentTarget.dataset.domainsCopyValue
    navigator.clipboard.writeText(value).then(() => {
      const btn = event.currentTarget
      const original = btn.innerHTML
      btn.innerHTML = '<span class="font-sans not-italic text-green-600 text-xs font-medium">Copied</span>'
      setTimeout(() => { btn.innerHTML = original }, 2000)
    })
  }
}
